import i18n from '@/i18n';
import { getAll } from '@/api/ligneCommande';
import store from '@/store/store';
import { TYPE_COMMANDE, SENS_VENTE } from '@/configuration/devisConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import getDateAnneeSemaine from '@/services/devisCommandes/getDateAnneeSemaine';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';

function genererWarningTfs(tfs, lignes) {
  const warningObjet = {
    selected: true,
    codeFace: tfs.produitReference,
    motifs: [],
    commandes: [],
  };
  lignes.forEach((ligne) => {
    let motif = '';
    warningObjet.commandes.push({
      code: ligne.devisCommande.code,
      annonceurs: ligne.devisCommande.intervenants.filter((int) => {
        return int.annonceur;
      }).map(inter => inter.nomCommercial).join(', '),
      id: ligne.devisCommande.id,
    });
    if (ligne.aIntegrerDansLaLogistique) {
      motif = ligne.typeProduit === CATEGORIE_REGROUPEMENT ? i18n.t('gestionAffectation.warningCard.faceSurVenteReseau', { libelleReseau: ligne.libelle })
        : i18n.t('gestionAffectation.warningCard.faceSurVenteLc');
    } else {
      motif = ligne.typeProduit === CATEGORIE_REGROUPEMENT ? i18n.t('gestionAffectation.warningCard.faceSurVenteReseauNonGere', { libelleReseau: ligne.libelle })
        : i18n.t('gestionAffectation.warningCard.faceSurVenteLcNonGere');
    }
    warningObjet.motifs.push(motif);
  });
  return warningObjet;
}

async function getLignesCommandesForWeek(tfsSelectionnes, anneeSemaine) {
  let produitsIds = [];
  tfsSelectionnes.forEach((tfs) => {
    if (tfs.produitsRegroupementsId) {
      produitsIds = produitsIds.concat(tfs.produitsRegroupementsId.split('|'));
    }
    produitsIds.push(tfs.produitId);
  });
  const dateDebut = getDateAnneeSemaine(anneeSemaine);
  const dateFin = dateDebut.add(6, 'd').toDate();

  const lignesCommandes = (await getAll({
    query: {
      societeId: store.getters['societe/societeActiveId'],
      produitsIds: [...new Set(produitsIds)],
      sens: SENS_VENTE,
      dates: {
        dateDebut: formatIsoDate(dateDebut),
        dateFin: formatIsoDate(dateFin),
      },
      typesDevisCommandeFacture: [TYPE_COMMANDE],
    },
  })).data.result.items;
  return lignesCommandes;
}

export default async function searchTfsWithWarning(tfsSelectionnes, anneeSemaine) {
  const tfsWithWarning = [];
  const lignesCommandes = await getLignesCommandesForWeek(tfsSelectionnes, anneeSemaine);

  tfsSelectionnes.forEach((tfs) => {
    let lignesForTfs = [];
    if (tfs.produitsRegroupementsId) {
      lignesForTfs = lignesForTfs.concat(lignesCommandes.filter((ligne) => {
        return tfs.produitsRegroupementsId.includes(ligne.produitId);
      }));
    }
    lignesForTfs = lignesForTfs.concat(lignesCommandes.filter((ligne) => {
      return ligne.produitId === tfs.produitId;
    }));
    if (lignesForTfs.length) tfsWithWarning.push(genererWarningTfs(tfs, lignesForTfs));
  });
  return tfsWithWarning;
}
